import { SHOP, SERVICES } from "@/lib/api";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-[#2e2e2e] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-4">
            <Logo className="h-24 w-24 object-contain" />
            <div className="leading-none">
              <div className="font-['Anton'] text-chrome text-3xl tracking-wide">MID DEL AUTO</div>
              <div className="font-['Exo_2'] text-[10px] uppercase tracking-[0.35em] text-gray-500 font-bold mt-1.5">Complete Auto Repair</div>
            </div>
          </div>
          <p className="font-['Exo_2'] text-gray-500 text-sm max-w-md leading-relaxed">
            Honest, dependable auto repair in Midwest City, Oklahoma. From oil to engines — we keep you moving.
          </p>
        </div>
        <div>
          <div className="font-['Exo_2'] text-[10px] uppercase tracking-[0.3em] text-[#e10600] font-bold mb-4">Services</div>
          <ul className="space-y-2">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.key}>
                <a href="#services" className="font-['Exo_2'] text-gray-400 hover:text-white text-sm transition-colors">{s.key}</a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="font-['Exo_2'] text-[10px] uppercase tracking-[0.3em] text-[#e10600] font-bold mb-4">Visit</div>
          <ul className="space-y-2 font-['Exo_2'] text-gray-400 text-sm">
            <li>{SHOP.address}</li>
            <li><a href={`tel:${SHOP.phoneTel}`} className="hover:text-white">{SHOP.phone}</a></li>
            <li>{SHOP.hours}</li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-6 border-t border-[#2e2e2e] flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="font-['Exo_2'] text-gray-600 text-xs uppercase tracking-widest">© {new Date().getFullYear()} Mid Del Auto. All rights reserved.</div>
        <div className="font-['Exo_2'] text-gray-700 text-[10px] uppercase tracking-[0.3em]">Honest work • Done right</div>
      </div>
    </footer>
  );
};

export default Footer;
